<h3 mat-dialog-title class="title">
  {{ 'coupons.segments.grid.users.modal.title' | translate }}
</h3>

<mat-dialog-content>
    <div class="content">
          <div class="input-container">
            <mat-form-field
              class="search-input">
              <i matPrefix class="tce-icon-search"></i>
              <input matInput [value]="searchText" (input)="searchText=$event.target.value" [placeholder]="'coupons.segments.grid.users.modal.search' | translate">
            </mat-form-field>

            <div class="search-actions">
              <txp-type-selector class="search-type-selector"
                                 [selected]="selectedSearchType"
                                 [columns]="3"
                                 [types]="searchTypes"
                                 (select)="selectedSearchType = $event">
              </txp-type-selector>
              <txp-button data-qa-label="SearchFiltersButton"
                          [style]="buttonStyle.PRIMARY"
                          [size]="buttonSize.SMALL"
                          [loading]="isLoading"
                          [disabled]="isLoading"
                          (click)="getUsers()">
                {{ 'coupons.segments.grid.users.modal.searchBtn' | translate }}
              </txp-button>
            </div>
          </div>
    </div>

    <div class="table-content">
        <table mat-table
                [dataSource]="dataSource"
                matSort
                matSortActive="name"
                matSortDirection="asc"
                matSortDisableClear>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'coupons.segments.grid.users.name' | translate }}</th>
            <td mat-cell *matCellDef="let user"> {{ user.firstName + ' ' + user.lastName }} </td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header >{{ 'coupons.segments.grid.users.email' | translate }}</th>
            <td mat-cell *matCellDef="let user"> {{ user.email }} </td>
        </ng-container>

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header >{{ 'coupons.segments.grid.users.id' | translate }}</th>
            <td mat-cell *matCellDef="let user"> {{ user.userId }} </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let user">
                <ng-container>
                    <div class="row-actions">
                        <txp-button data-qa-label="AddButton"
                                    *ngIf="!addedItems[user.userId]"
                                    [style]="buttonStyle.LISTACTION"
                                    icon="tce-icon-add"
                                    [attr.title]="'coupons.segments.grid.users.modal.addBtn' | translate"
                                    (click)="addUser(user)">
                        </txp-button>

                        <txp-button data-qa-label="RemoveButton"
                                    *ngIf="addedItems[user.userId]"
                                    [style]="buttonStyle.LISTACTION"
                                    icon="tce-icon-trash"
                                    [attr.title]="'coupons.segments.grid.users.modal.removeBtn' | translate"
                                    (click)="removeUser(user)">
                        </txp-button>
                    </div>
                </ng-container>
            </td>
        </ng-container>

        <ng-container matColumnDef="empty">
          <tr mat-footer-cell *matFooterCellDef colspan="100">
            <div [hidden]="!searchDone || dataSource.data.length">
                <mat-label>No users found</mat-label>
            </div>
          </tr>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
        <tr mat-footer-row
            *matFooterRowDef="['empty']; sticky: true"
            [hidden]="!searchDone || dataSource.data.length"></tr>
        </table>
    </div>

</mat-dialog-content>
<mat-dialog-actions>
    <txp-button [style]="buttonStyle.SECONDARY"
                data-qa-label="CancelButton"
                (click)="handleCancel()">
        {{ 'form.button.cancel' | translate }}
   </txp-button>

    <txp-button [style]="buttonStyle.PRIMARY"
                data-qa-label="DoneButton"
                (click)="handleDone()">
        {{ 'form.button.done' | translate }}
    </txp-button>
</mat-dialog-actions>
